import type { TranslationMessages } from '../types';

export const grab: TranslationMessages = {
        mappings: {
          title: 'Đồng bộ Sản phẩm',
        },
        settings: {
          title: 'Cài đặt Tích hợp Grab',
        },
        sync: {
          title: 'Bảng Đồng bộ Menu',
        },
      };
